import React, { Component } from 'react';
import { Transition } from 'react-transition-group';
import { Link } from 'gatsby';
import Flickity from './Flickity';
import classNames from 'classnames';
import createTaxonomyLink from '../utils/createTaxonomyLink';
import { connectToStore } from './Provider';
import { opacityFadeDuration } from '../config/animation';

const BRAND_DEFAULT_STYLE = {
    transition: `opacity ${opacityFadeDuration}ms ease-in-out`,
    opacity: 0,
};

const BRAND_TRANSITION_STYLES = {
    entering: { opacity: 0 },
    entered: {
        opacity: 1,
        transition: `opacity ${opacityFadeDuration}ms ease-in-out ${opacityFadeDuration}ms`,
    },
    exiting: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
    }
};

const SLIDE_OPTIONS = {
    cellAlign: 'left',
    contain: true,
    wrapAround: false,
    pageDots: false,
    prevNextButtons: false,
    selectedAttraction: 0.1,
    friction: 0.8
};

class FeaturedBrandsCarousel extends Component {
    constructor() {
        super();

        this.state = {
            activeBrandIndex: 0,
        };
    }

    onClickPrevious = () => {
        if (this.state.activeBrandIndex <= 0) {
            this.setState({
                activeBrandIndex: this.props.brands.length - 1
            });
        } else {
            this.setState({
                activeBrandIndex: this.state.activeBrandIndex - 1
            });
        }

        // Move logo slider
        if (this.logoSlider) {
            this.logoSlider.previous();
        }
    }

    onClickNext = () => {
        if (this.state.activeBrandIndex >= this.props.brands.length - 1) {
            this.setState({
                activeBrandIndex: 0
            });
        } else {
            this.setState({
                activeBrandIndex: this.state.activeBrandIndex + 1
            });
        }

        // Move logo slider
        if (this.logoSlider) {
            this.logoSlider.next();
        }
    }

    onClickIndex = activeBrandIndex => {
        // Move logo slider
        if (this.logoSlider) {
            if (activeBrandIndex > this.state.activeBrandIndex) {
                this.logoSlider.next();
            } else if (activeBrandIndex < this.state.activeBrandIndex) {
                this.logoSlider.previous();
            }
        }

        // set active brand index
        this.setState({
            activeBrandIndex
        });
    }

    setSliderRef = slider => {
        this.logoSlider = slider;
    }

    render() {
        const {
            title,
            shopAllLink,
            brands,
            openVideoModal,
        } = this.props;

        const {
            activeBrandIndex
        } = this.state;

        const logoCarousel = (
            <Flickity
                sliderRef={this.setSliderRef}
                className="brand-carousel"
                key="logo-carousel"
                options={SLIDE_OPTIONS}>{brands.map((brand, index) => (
                    <button
                        title={brand.title}
                        key={`${index}_${brand._key}`}
                        className={classNames('brand-carousel__logo mr2 mr5--md', {
                            active: index === activeBrandIndex
                        })}
                        onClick={() => this.onClickIndex(index)}>
                        <img
                            className="db contained-width"
                            alt={brand.title}
                            src={brand.logo}
                        />
                    </button>
                ))}</Flickity>
        );

        const header = (
            <div className="media media--horizontal media--reverse gutter--small align--middle pb3 pb4--md">
                <div className="media__fluid">
                    <h2 className="uppercase fw--600">
                        {title}
                    </h2>
                </div>
                <div className="media__fixed">
                    <ul className="list list--horizontal list--forward gutter--small tr align--middle">
                        <li className="list__item">
                            <button
                                title="Previous"
                                onClick={this.onClickPrevious}
                                className="db"
                                name="previous">
                                <img
                                    alt="arrow"
                                    className="flip db"
                                    src="/images/icon-arrow-pagination.svg"
                                />
                            </button>
                        </li>
                        <li className="list__item show--md">
                            <p className="fw--500 sans--small ">
                                {activeBrandIndex + 1} of {brands.length}
                            </p>
                        </li>
                        <li className="list__item">
                            <button
                                title="Next"
                                onClick={this.onClickNext}
                                className="db"
                                name="next">
                                <img
                                    alt="arrow"
                                    className="db"
                                    src="/images/icon-arrow-pagination.svg"
                                />
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        );

        let shopAllLinkButton;

        if (shopAllLink._type === 'link') {
            if (shopAllLink.url[0] === '/') {
                shopAllLinkButton = (
                    <Link
                        className="button--secondary full-width"
                        title={shopAllLink.title}
                        to={shopAllLink.url}>
                        {shopAllLink.title}
                    </Link>
                );
            } else {
                shopAllLinkButton = (
                    <a
                        className="button--secondary full-width"
                        title={shopAllLink.title}
                        href={shopAllLink.url}>
                        {shopAllLink.title}
                    </a>
                );
            }
        } else if (shopAllLink._type === 'videoModalLink') {
            shopAllLinkButton = (
                <button
                    title={shopAllLink.title}
                    className="button--secondary full-width"
                    onClick={() => openVideoModal(shopAllLink.videoId)}
                    name="video">
                    {shopAllLink.title}
                </button>
            );
        } else if (shopAllLink._type === 'taxonomyLink') {
            shopAllLinkButton = (
                <Link
                    className="button--secondary full-width"
                    title={shopAllLink.title}
                    to={createTaxonomyLink(shopAllLink.taxonomies)}>
                    {shopAllLink.title}
                </Link>
            );
        }

        const brandSlides = brands.map((brand, index) => {
            let brandButton;

            if (brand.brandLink) {
                if (brand.brandLink._type === 'link') {
                    if (brand.brandLink.url[0] === '/') {
                        brandButton = (
                            <Link
                                className="button--primary-black full-width"
                                title={brand.brandLink.title}
                                to={brand.brandLink.url}>
                                {brand.brandLink.title}
                            </Link>
                        );
                    } else {
                        brandButton = (
                            <a
                                className="button--primary-black full-width"
                                title={brand.brandLink.title}
                                href={brand.brandLink.url}>
                                {brand.brandLink.title}
                            </a>
                        );
                    }
                } else if (brand.brandLink._type === 'videoModalLink') {
                    brandButton = (
                        <button
                            title={brand.brandLink.title}
                            className="button--primary-black full-width"
                            onClick={() => openVideoModal(brand.brandLink.videoId)}
                            name="video">
                            {brand.brandLink.title}
                        </button>
                    );
                } else if (brand.brandLink._type === 'taxonomyLink') {
                    brandButton = (
                        <Link
                            className="button--primary-black full-width"
                            title={brand.brandLink.title}
                            to={createTaxonomyLink(brand.brandLink.taxonomies)}>
                            {brand.brandLink.title}
                        </Link>
                    );
                }
            }

            return (
                <Transition
                    key={`${index}_${brand._key}`}
                    in={index === activeBrandIndex}
                    mountOnEnter
                    unmountOnExit
                    appear
                    timeout={{
                        enter: 0,
                        exit: opacityFadeDuration,
                    }}>{(state) => (
                        <div
                            className="pt3 pt8--md pb8--md"
                            style={{
                                ...BRAND_DEFAULT_STYLE,
                                ...BRAND_TRANSITION_STYLES[state]
                            }}>
                            <div className="row align--middle direction--rev--md">
                                <div className="col c6--md mb2 mb0--md">
                                    <div className="image size--4x3">
                                        <picture>
                                            <img
                                                alt={brand.title}
                                                src={`${brand.brandImage}?w=800&auto=format`}
                                            />
                                        </picture>
                                    </div>
                                </div>
                                <div className="col c6--md mb2 mb0--md">
                                    <h3 className="domaine--large brand-carousel__title">{brand.title}</h3>
                                    <p className="sans--medium mb2 pr10--lg">{brand.subtitle}</p>
                                    <p className="color--gray-text mb3 mb4--md pr8--xl">{brand.description}</p>
                                    <div className="row gutter--mobile">
                                        <div className="col c6--md c5--xl mb2 mb0--md">
                                            {brandButton}
                                        </div>
                                        <div className="col c6--md c5--xl">
                                            {shopAllLinkButton}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}</Transition>
            );
        });

        return (
            <div className="of--hidden grid-container contained mt10 mb10">
                <div className="pt5--md pb2--md">
                    {header}
                    <hr className="show--md" />
                    <div className="hide--md">
                        {logoCarousel}
                    </div>
                    <div className="pr">
                        {brandSlides}
                    </div>
                    <div className="show--md">
                        {logoCarousel}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = () => ({});

const mapStoreToProps = ({
    openVideoModal,
}) => ({
    openVideoModal,
});

export default connectToStore(mapStateToProps, mapStoreToProps)(FeaturedBrandsCarousel);